import {ZIDX, ZIDXPage} from "../../../../standalone/standaloneLibrary.js";

export class ZIDXAccountRetsServers implements ZIDXPage{
    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
    }
    getPageClass(){
        return "zidxAccountRetsServersContainer";
    }
    render(){
        // console.log("data feeds");
    }
}